module.exports = __webpack_public_path__ + "img/DW365-307.70b7864f.jpg";